import {
  ORG_PROJECTS_QUERY_KEY,
  PROJECTS_QUERY_KEY,
} from "@frontend-shared/constants";
import type { IEditProjectParams } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { projectApi } from "@/api/services";

interface IEditProjectMutationParams extends IEditProjectParams {
  organizationUuid: string;
}

export const useEditProject = () => {
  const { t } = useTranslation("settings");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ uuid, data }: IEditProjectMutationParams) =>
      projectApi.edit({ uuid, data }),
    onSuccess: (_data, { organizationUuid }) => {
      queryClient.invalidateQueries({
        queryKey: [ORG_PROJECTS_QUERY_KEY, organizationUuid],
      });
      queryClient.invalidateQueries({
        queryKey: [PROJECTS_QUERY_KEY],
      });
      toast.success(t("projects.edit.success"));
    },
    meta: {
      fallbackMessage: t("projects.edit.error"),
    },
  });
};
